/** Non-negative integer quantity parsed from a digit-only draft string. */
export function parseQuantityDraftText(text: string): number {
  if (text === '') {
    return 0;
  }
  const parsed = Number.parseInt(text, 10);
  if (Number.isNaN(parsed)) {
    return 0;
  }
  return Math.max(0, parsed);
}

/** Keep only ASCII digits — allows empty while the operator is typing. */
export function sanitizeQuantityDraftText(raw: string): string {
  return raw.replace(/\D/g, '');
}

export function formatQuantityDraftText(quantity: number): string {
  return String(Math.max(0, Math.floor(quantity)));
}

export const QUANTITY_STEP_SIZES = [1, 5, 10] as const;

export type QuantityStepSize = (typeof QUANTITY_STEP_SIZES)[number];
